import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import PageContent from "../PageContent";
import { applicationSubmit } from "../../logic/actions/api/application";
import { go } from "../../logic/actions/navigation";
import { logEvent, STEP_COMPLETED } from "../../logic/eventLogger";
import { APPROVED, DECLINED, REVIEWING } from "../../logic/enums/pages";

export default function PageThankYou() {
  const dispatch = useDispatch();
  const [error, setError] = useState("");

  const [mounted, setMounted] = useState(true);
  const showEvalResults = useSelector((store) => {
    const {
      showApplicationResults,
    } = store.configuration.extraConfig.featureFlags;
    //resolving serialization problem
    return showApplicationResults === "true" || showApplicationResults === true;
  });

  useEffect(() => {
    applicationSubmit()(dispatch)
      .then((response) => {
        logEvent(STEP_COMPLETED, { value: "application_submitted" });
        logEvent(STEP_COMPLETED + "_application_submitted");
        if (mounted) {
          if (response.message) {
            setError(response.message);
            return;
          }
          if (showEvalResults) {
            if (response.status === "AUTO_APPROVED") {
              go(APPROVED)(dispatch);
            } else if (response.status === "AUTO_DECLINED") {
              go(DECLINED)(dispatch);
            } else {
              //"REVIEW_REQUIRED"
              go(REVIEWING)(dispatch);
            }
          }
        }
      })
      .catch((error) => {
        if (mounted) {
          setError(error);
        }
      });
    return () => {
      setMounted(false);
    };
  });

  return (
    <PageContent progressBar={true} progressPercentage={100}>
      <header />
      {showEvalResults ? (
        <>
          <h1>Thank you!</h1>
          <p className="center">
            We are processing your application, please keep this window open.
          </p>
        </>
      ) : (
        <h1>Thank you for your application.</h1>
      )}
      <p className="center error">{error}</p>
    </PageContent>
  );
}
